var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_148_14857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.99594 1.99625C3.09995 1.99625 3.99188 2.88818 3.99188 3.99219V19.9597H17.9635V9.98001C17.9635 8.87601 18.8554 7.98407 19.9594 7.98407H33.931C37.2368 7.98407 39.9188 10.6661 39.9188 13.9719V27.9435C39.9188 29.0475 39.0269 29.9394 37.9229 29.9394C36.8189 29.9394 35.9269 29.0475 35.9269 27.9435V25.9475H21.9554H19.9594H3.99188V27.9435C3.99188 29.0475 3.09995 29.9394 1.99594 29.9394C0.891936 29.9394 0 29.0475 0 27.9435V3.99219C0 2.88818 0.891936 1.99625 1.99594 1.99625ZM10.9777 7.98407C12.3011 7.98407 13.5703 8.50979 14.506 9.44556C15.4418 10.3813 15.9675 11.6505 15.9675 12.9739C15.9675 14.2973 15.4418 15.5665 14.506 16.5023C13.5703 17.4381 12.3011 17.9638 10.9777 17.9638C9.65429 17.9638 8.3851 17.4381 7.44932 16.5023C6.51354 15.5665 5.98782 14.2973 5.98782 12.9739C5.98782 11.6505 6.51354 10.3813 7.44932 9.44556C8.3851 8.50979 9.65429 7.98407 10.9777 7.98407Z",
    fill: "#CC7480"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_148_14857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.9188,
    height: 31.9351,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedSolid);
export default __webpack_public_path__ + "static/media/bed-solid.b7eeecba6721f58c3f96914895dda068.svg";
export { ForwardRef as ReactComponent };